import { useEffect } from 'react';
import { useErrorContext } from 'context/errorContext';
import { useGetUserProgressByTopicQuery } from 'services/api/makesApi/makesApi';
const useGetUserProgressByTopic = ({ topicId, userId }) => {
  const { handleError } = useErrorContext();
  const {
    data,
    error: getUserProgressByTopicError,
    isLoading,
  } = useGetUserProgressByTopicQuery(
    { topicId, userId },
    {
      skip: !topicId || !userId,
    }
  );
  useEffect(() => {
    if (getUserProgressByTopicError) handleError(getUserProgressByTopicError);
  }, [getUserProgressByTopicError]);

  return { data, isLoading };
};

export default useGetUserProgressByTopic;
